const STRIPPED_UUID_RE = /^[0-9a-f]{32}$/i;
const DASHED_UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Restore dashes to a 32-char hex UUID. The chat stream's `data-done` part
 *  hands conversation (and message) ids back in stripped form
 *  (`587107e7ce494b9098b124eb43d6c760`), but the REST catalog endpoints
 *  (`/conversations`, `/conversations/:id`) use the canonical dashed form
 *  — mixing the two shapes as state/cache keys makes the same conversation
 *  look like two different ones. Already-dashed ids and anything that
 *  doesn't look like a UUID pass through unchanged. */
export function toCanonicalUuid(id: string): string {
  if (!id || DASHED_UUID_RE.test(id)) return id;
  if (!STRIPPED_UUID_RE.test(id)) return id;
  return [
    id.slice(0, 8),
    id.slice(8, 12),
    id.slice(12, 16),
    id.slice(16, 20),
    id.slice(20, 32),
  ].join('-');
}
